import * as THREE from 'three';

const basic = 844 / 390;

export function Scale() {
    let ratio = window.innerHeight / window.innerWidth;
    function set(value: number) {
        ratio = value;
    }   
    function get() {
        return Number((ratio / basic).toFixed(2));
    }
    function getCenterScale() {
        const center = (ratio + basic) / 2
        return Number((center / basic).toFixed(2));
    }
    return { set, get, getCenterScale }
}
const { get: getScale, set: setScale, getCenterScale } = Scale();
export { setScale, getScale, getCenterScale }

/**
 * 从球的孔洞散发出去的光的名字
 */
export const LIGHT_NAME_LIST = ['Cylinder145', 'Cylinder147'];

/**
 * 球初始状态的大小
 */
export const BALL_INIT_SIZE = 0;

/**
 * 球初始状态的位置
 */
export const BALL_INIT_POSITION = new THREE.Vector3(-1, 0, 0);

/**
 * 球在显微镜阶段时的位置
 */
export const BALL_MICRO_POSITION = new THREE.Vector3(-1, 0, 0);

/**
 * 球在显微镜阶段时的大小
 */
export const BALL_MICRO_SIZE = 3;

/**
 * 显微镜阶段，球渐进的时间
 */
export const BALL_ENTER_DURATION = 3500;

/**
 * 球在中心阶段时的位置
 */
export const BALL_CENTER_POSITION = new THREE.Vector3(0, 1, 0);

/**
 * 球在中心阶段时的大小
 */
// export const BALL_CENTER_SIZE = 4.5 * scale;
export function getBallCenterSize() {
    return 4.5 * getScale();
}

/**
 * 球移动到中心的时间
 */
export const BALL_CENTER_DURATION = 1000;